// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/*---------------------------------------- popuup ----------------------------------------*/

/* Modal Popup Background */
.modal-content {
  margin-top: -400px;
  background-color: #f8f9fa; /* Light background */
  border-radius: 8px; /* Rounded corners */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Soft shadow */
}

/* Modal Header */
.modal-header {
  background-color: #df8005; /* Primary color */
  color: white; /* White text */
  border-bottom: none; /* Remove default border */
  border-top-left-radius: 8px; /* Smooth corners */
  border-top-right-radius: 8px;
}

.modal-title {
  font-weight: bold; /* Bold title */
  font-size: 1.5rem; /* Increase font size */
}

/* Modal Close Button */
.modal-header .btn-close {
  color: white; /* White close button */
  opacity: 1; /* Full opacity */
}

/* Modal Body */
.modal-body {
  padding: 20px;
}

/* Button Styles */
.modal-body .btn-primary {
  background-color: #28a745; /* Green button */
  border-color: #28a745;
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  padding: 10px 15px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

.modal-body .btn-primary:hover {
  background-color: #218838; /* Darker green on hover */
}

.modal-body .btn-danger {
  background-color: #dc3545; /* Red button */
  border-color: #dc3545;
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  padding: 10px 15px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

.modal-body .btn-danger:hover {
  background-color: #c82333; /* Darker red on hover */
}

/* Full-width button */
.w-100 {
  width: 100%;
}

/* Modal Footer */
.modal-footer {
  border-top: none; /* Remove footer border */
  padding-top: 0;
}

/* Mobile Responsive */
@media (max-width: 576px) {
  .modal-content {
    width: 90%; /* Adjust width for smaller screens */
  }
}





.logo-container {
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
height: 10vh;
  width: 100%; /* Full width */
  box-sizing: border-box; /* Include padding and border in width/height */
  background-color: #f9f9f9; /* Optional background color */

}

.modulename {
  font-size: 1.5em; /* Responsive font size */
  font-weight: bold;
  color: #333; /* Text color */
  text-align: center; /* Ensure text alignment */
}





  
/* **** Carousel css ***========================================================================================================== */

/* Carousel.css */
.carousel-container {
  width: 150%;
  /* height: 350px; */
  /* margin-top: 90px; */
  /* animation: zoom 10s infinite; */
}

.carousel-img{
  height: 350px;
}


/* @keyframes zoom {
  0% {
    transform: scale(1); 
  }
  50% {
    transform: scale(1.05); 
  }
  100% {
    transform: scale(1); 
  }
} */

/* For laptop screens (1024px to 1440px) */
@media (min-width: 1024px) and (max-width: 1440px) {
  .carousel-container {
    /* height: 300px; */
    margin-top: 80px;
    width: 100%;
  }

  .carousel-img{
    height: 350px;
  }
}

/* For tablets (768px to 1024px) */
@media (max-width: 1024px) and (min-width: 769px) {
  .carousel-container {
    /* height: 250px; */
    margin-top: 75px;
  }

  .carousel-img{
    height: 350px;
  }
}

/* For medium devices (up to 768px) */
@media (max-width: 768px) {
  .carousel-container {
    width: 100%;
    /* height: 200px; */
    margin-top: 70px;
  }

  .carousel-img{
    height: 200px;
  }
}

/* For small devices (up to 576px) */
@media (max-width: 576px) {
  .carousel-container {
    width: 100%;
    /* height: 50px;  */
    margin-top: 60px;
  }

  .carousel-img{
    height: 150px;
  }
}


/* ***********************  Horizontal Header css ********************* */


/* Container for header list */
.header-container {
  /* margin-top: 50px; */
  position: relative;
  width: 100%;
  /* overflow-x: auto; */
  padding: 10px;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  /* margin-left: 15px; */
}

/* Horizontal list styling */
.header-list {
  display: flex;
  justify-content: flex-start;
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 100%;
  flex-wrap: wrap;
 color:'black'
}

.header-item {
  position: relative; /* Needed for the active bar positioning */
  padding: 10px 20px;
  cursor: pointer;
  font-size: 1rem;
  white-space: nowrap;
  transition: color 0.3s ease;
  text-align: center;
  flex: 0 0 auto; /* Allow item to take its own width */
}

.header-item h6{
  font-size: 1.0rem;
}

.header-item.active {
  color:rgb(233,182,16);
}

/* Active bar inside the header-item */
.active-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  width: 100%; /* Takes the full width of the header item */
  background-color:rgb(255, 196, 0);
  transition: all 0.3s ease;
}


/* Responsive styles */
@media (max-width: 900px) {
  .header-item h6{
    font-size: 0.9rem;
  }
}


/* Responsive styles */
@media (max-width: 768px) {
  .header-item {
    font-size: 0.9rem;
    padding: 8px 15px;
  }

  .header-item h6{
    font-size: 0.8rem;
  }
}

@media (max-width: 576px) {
  .header-list {
    justify-content: flex-start;
    padding-left: 10px;
  }

  .header-item {
    font-size: 0.8rem;
    padding: 6px 10px;
    flex: 0 0 auto;
  }

  .header-item h6{
    font-size: 0.6rem;
  }

  .active-bar {
    height: 2px;
  }
}



/* *********** Card UI ******************** */







.Mro-container {
  display: flex;
  justify-content: center; /* Centers the container horizontally */
  align-items: center; /* Centers the container vertically */
  padding: 20px;
  width: 100%; /* Full width for responsiveness */
  box-sizing: border-box;
}

/* Card wrapper: Left-aligned content within the centered container */
.Mroimage-card {
  display: flex;
  flex-wrap: wrap; /* Allows wrapping to new rows */
  gap: 20px; /* Space between cards */
  justify-content: flex-start; /* Align cards to the left */

}

/* Individual card styling */
.Mroimage-card-content {
  background: rgba(237, 214, 115, 0.2);
  border-radius: 10px;
  overflow: hidden;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(237, 230, 230, 0.2);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 4px solid rgb(251, 222, 6);
  transition: transform 0.3s ease;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(25% - 20px); /* Default: 4 cards per row */
  max-width: 250px; /* Prevent card from growing too large */
  /* height: 400px; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
}
.Mrocard-image {
  width: 100%; /* Allow the image to take the full width of its container */
height: auto;
max-width: 200px; /* Default max width */
max-height: 200px; /* Default max height */
 object-fit: cover; /* Ensures the image fits within the specified dimensions */
 border-radius: 8px; /* Keep the rounded corners */
margin: 0 auto; /* Center the image horizontally */
}

.Mrocard-details {
  text-align: center;
  margin-top: 10px;
}

.Mrocard-details h2 {
  font-size: 1em; /* Default font size for heading */
  color: #120e0e;
}

.Mrocard-detailsOne,
.Mrocard-detailsTwo {
  margin: 5px;
  font-size: 12px; /* Default font size */
  color: #0e4306;
}

/* .MroImage-container{
width:225px;
margin-left: -10px;
margin-top:-10px ;
height:900px;



} */

/* From 900px to 1280px: Maintain 4 cards per row */
@media (max-width: 1280px) and (min-width: 901px) {
  .Mroimage-card-content {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(25% - 20px); /* 4 cards per row */
    max-width: 250px; /* Prevent card from growing too large */
    height: 350px;
  }

  .Mrocard-image {
    max-width: 180px;
    max-height: 180px;
    justify-content: center;
    margin: 0 auto; /* Center the image horizontally */
  }
  .Mrocard-details h2 {
    font-size: 1em;
  }

  .Mrocard-detailsOne,
  .Mrocard-detailsTwo {
    font-size: 12px;
  }
}
/* From 600px to 900px: Show 3 cards per row */
@media (max-width: 900px) and (min-width: 601px) {
  .Mroimage-card-content {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.33% - 20px); /* 3 cards per row */
    height: 300px;
  }
  .Mrocard-image {
    max-width: 130px;
    max-height: 130px;
    margin: 0 auto; /* Center the image horizontally */
  }
  .Mrocard-details h2 {
    font-size: 1em;
  }
  .Mrocard-detailsOne,
  .Mrocard-detailsTwo {
    font-size: 12px;
  }
}

/* From 400px to 599px: Show 2 cards per row */
@media (max-width: 600px) and (min-width: 401px) {
  .Mroimage-card-content {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 20px); /* 2 cards per row */
  }
  .Mrocard-image {
    max-width: 130px;
    max-height: 130px;
  
  }
  .Mrocard-details h2 {
    font-size: 0.9em;
  }
  .Mrocard-detailsOne,
  .Mrocard-detailsTwo {
    font-size: 11px;
  }
}

/* Below 400px: Show 1 card per row */
@media (max-width: 400px) {
  .Mroimage-card-content {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(100% - 20px); /* 1 card per row */
  }

  .Mrocard-image {
    max-width: 140px;
    max-height: 140px;
  }
  .Mroimage-card {
    justify-content: center;
  }
  .Mrocard-details h2 {
    font-size: 0.8em;
  }

  .Mrocard-detailsOne,
  .Mrocard-detailsTwo {
    font-size: 10px;
  }
}


/* *******************  Module-Container ************************* */
/* CSS for the modules-container to look like a dropdown */
.modules-container {
  margin: 13px auto;
  display: none;               /* Initially hidden */
  position: absolute;          /* Positioned relative to the nearest positioned ancestor */
  background-color: white;     /* Background color */
  border: 2px solid rgb(255, 214, 11);      /* Light border */
  border-radius: 4px;          /* Rounded corners */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Shadow for depth */
  z-index: 1000;              /* Ensure it's on top of other elements */
  width: max-content;          /* Adjust width to content */
  max-height: 300px;          /* Maximum height for dropdown */
  overflow-y: auto;           /* Scroll if content exceeds max height */
  padding: 10px;              /* Padding for better spacing */
  left: 0px;
  /* max-width: 70vw; */
}

/* Show the dropdown when the show class is applied */
.modules-container.show {
  display: block;              /* Show the dropdown */
}

/* Styles for individual module items */
.module-item {
  padding: 8px 12px;          /* Padding for each item */
  cursor: pointer;            /* Pointer cursor */
  transition: background-color 0.3s; /* Transition for hover effect */
  text-align: left;
  color:#0b0808
}

/* Change background color on hover for module items */
.module-item:hover {
  background-color:rgba(0, 0, 0, 0.2); /* Light gray background on hover */
}

/* Style for no modules available message */
.modules-container p {
  padding: 10px;              /* Padding for the message */
  margin: 0;                  /* Remove margin */
  color: #777;                /* Gray color for the message */
       /* Center align the message */
}`, "",{"version":3,"sources":["webpack://./src/Components/Labs/Labs.css"],"names":[],"mappings":";AACA,2FAA2F;;AAE3F,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,yBAAyB,EAAE,qBAAqB;EAChD,kBAAkB,EAAE,oBAAoB;EACxC,yCAAyC,EAAE,gBAAgB;AAC7D;;AAEA,iBAAiB;AACjB;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,YAAY,EAAE,eAAe;EAC7B,mBAAmB,EAAE,0BAA0B;EAC/C,2BAA2B,EAAE,mBAAmB;EAChD,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB,EAAE,eAAe;EAClC,iBAAiB,EAAE,uBAAuB;AAC5C;;AAEA,uBAAuB;AACvB;EACE,YAAY,EAAE,uBAAuB;EACrC,UAAU,EAAE,iBAAiB;AAC/B;;AAEA,eAAe;AACf;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,gBAAgB,EAAE,yBAAyB;EAC3C,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU,EAAE,qCAAqC;EACnD;AACF;;;;;;AAMA;EACE,aAAa;EACb,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB,EAAE,sBAAsB;AAC7C,YAAY;EACV,WAAW,EAAE,eAAe;EAC5B,sBAAsB,EAAE,+CAA+C;EACvE,yBAAyB,EAAE,8BAA8B;;AAE3D;;AAEA;EACE,gBAAgB,EAAE,yBAAyB;EAC3C,iBAAiB;EACjB,WAAW,EAAE,eAAe;EAC5B,kBAAkB,EAAE,0BAA0B;AAChD;;;;;;;AAOA,oIAAoI;;AAEpI,iBAAiB;AACjB;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;;AAGA;;;;;;;;;;GAUG;;AAEH,0CAA0C;AAC1C;EACE;IACE,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;;AAGA,yEAAyE;;;AAGzE,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,WAAW;EACX,eAAe;CAChB;AACD;;AAEA;EACE,kBAAkB,EAAE,0CAA0C;EAC9D,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc,EAAE,qCAAqC;AACvD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW,EAAE,4CAA4C;EACzD,iCAAiC;EACjC,yBAAyB;AAC3B;;;AAGA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;AACF;;;AAGA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF;;;;AAIA,6CAA6C;;;;;;;;AAQ7C;EACE,aAAa;EACb,uBAAuB,EAAE,uCAAuC;EAChE,mBAAmB,EAAE,qCAAqC;EAC1D,aAAa;EACb,WAAW,EAAE,kCAAkC;EAC/C,sBAAsB;AACxB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,eAAe,EAAE,gCAAgC;EACjD,SAAS,EAAE,wBAAwB;EACnC,2BAA2B,EAAE,4BAA4B;;AAE3D;;AAEA,4BAA4B;AAC5B;EACE,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,8CAA8C;EAC9C,2BAA2B;EAC3B,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;EAC/B,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B,EAAE,6BAA6B;EACzD,gBAAgB,EAAE,wCAAwC;EAC1D,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,WAAW,EAAE,4DAA4D;AAC3E,YAAY;AACZ,gBAAgB,EAAE,sBAAsB;AACxC,iBAAiB,EAAE,uBAAuB;CACzC,iBAAiB,EAAE,2DAA2D;CAC9E,kBAAkB,EAAE,6BAA6B;AAClD,cAAc,EAAE,kCAAkC;AAClD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,kCAAkC;EAClD,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,eAAe,EAAE,sBAAsB;EACvC,cAAc;AAChB;;AAEA;;;;;;;;GAQG;;AAEH,mDAAmD;AACnD;EACE;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B,EAAE,oBAAoB;IAChD,gBAAgB,EAAE,wCAAwC;IAC1D,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,cAAc,EAAE,kCAAkC;EACpD;EACA;IACE,cAAc;EAChB;;EAEA;;IAEE,eAAe;EACjB;AACF;AACA,8CAA8C;AAC9C;EACE;IACE,YAA6B;IAA7B,cAA6B;IAA7B,+BAA6B,EAAE,oBAAoB;IACnD,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,cAAc,EAAE,kCAAkC;EACpD;EACA;IACE,cAAc;EAChB;EACA;;IAEE,eAAe;EACjB;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B,EAAE,oBAAoB;EAClD;EACA;IACE,gBAAgB;IAChB,iBAAiB;;EAEnB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,eAAe;EACjB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,YAA2B;IAA3B,cAA2B;IAA3B,6BAA2B,EAAE,mBAAmB;EAClD;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;AACF;;;AAGA,oEAAoE;AACpE,0DAA0D;AAC1D;EACE,iBAAiB;EACjB,aAAa,gBAAgB,qBAAqB;EAClD,kBAAkB,WAAW,2DAA2D;EACxF,uBAAuB,MAAM,qBAAqB;EAClD,mCAAmC,OAAO,iBAAiB;EAC3D,kBAAkB,WAAW,oBAAoB;EACjD,wCAAwC,EAAE,qBAAqB;EAC/D,aAAa,eAAe,yCAAyC;EACrE,kBAAkB,WAAW,4BAA4B;EACzD,iBAAiB,WAAW,gCAAgC;EAC5D,gBAAgB,YAAY,yCAAyC;EACrE,aAAa,eAAe,+BAA+B;EAC3D,SAAS;EACT,qBAAqB;AACvB;;AAEA,qDAAqD;AACrD;EACE,cAAc,eAAe,sBAAsB;AACrD;;AAEA,uCAAuC;AACvC;EACE,iBAAiB,WAAW,0BAA0B;EACtD,eAAe,aAAa,mBAAmB;EAC/C,iCAAiC,EAAE,gCAAgC;EACnE,gBAAgB;EAChB;AACF;;AAEA,sDAAsD;AACtD;EACE,mCAAmC,EAAE,mCAAmC;AAC1E;;AAEA,2CAA2C;AAC3C;EACE,aAAa,eAAe,4BAA4B;EACxD,SAAS,mBAAmB,kBAAkB;EAC9C,WAAW,iBAAiB,+BAA+B;OACtD,6BAA6B;AACpC","sourcesContent":["\r\n/*---------------------------------------- popuup ----------------------------------------*/\r\n\r\n/* Modal Popup Background */\r\n.modal-content {\r\n  margin-top: -400px;\r\n  background-color: #f8f9fa; /* Light background */\r\n  border-radius: 8px; /* Rounded corners */\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Soft shadow */\r\n}\r\n\r\n/* Modal Header */\r\n.modal-header {\r\n  background-color: #df8005; /* Primary color */\r\n  color: white; /* White text */\r\n  border-bottom: none; /* Remove default border */\r\n  border-top-left-radius: 8px; /* Smooth corners */\r\n  border-top-right-radius: 8px;\r\n}\r\n\r\n.modal-title {\r\n  font-weight: bold; /* Bold title */\r\n  font-size: 1.5rem; /* Increase font size */\r\n}\r\n\r\n/* Modal Close Button */\r\n.modal-header .btn-close {\r\n  color: white; /* White close button */\r\n  opacity: 1; /* Full opacity */\r\n}\r\n\r\n/* Modal Body */\r\n.modal-body {\r\n  padding: 20px;\r\n}\r\n\r\n/* Button Styles */\r\n.modal-body .btn-primary {\r\n  background-color: #28a745; /* Green button */\r\n  border-color: #28a745;\r\n  color: white;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  padding: 10px 15px;\r\n  border-radius: 5px;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.modal-body .btn-primary:hover {\r\n  background-color: #218838; /* Darker green on hover */\r\n}\r\n\r\n.modal-body .btn-danger {\r\n  background-color: #dc3545; /* Red button */\r\n  border-color: #dc3545;\r\n  color: white;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  padding: 10px 15px;\r\n  border-radius: 5px;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.modal-body .btn-danger:hover {\r\n  background-color: #c82333; /* Darker red on hover */\r\n}\r\n\r\n/* Full-width button */\r\n.w-100 {\r\n  width: 100%;\r\n}\r\n\r\n/* Modal Footer */\r\n.modal-footer {\r\n  border-top: none; /* Remove footer border */\r\n  padding-top: 0;\r\n}\r\n\r\n/* Mobile Responsive */\r\n@media (max-width: 576px) {\r\n  .modal-content {\r\n    width: 90%; /* Adjust width for smaller screens */\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.logo-container {\r\n  display: flex;\r\n  justify-content: center; /* Center horizontally */\r\n  align-items: center; /* Center vertically */\r\nheight: 10vh;\r\n  width: 100%; /* Full width */\r\n  box-sizing: border-box; /* Include padding and border in width/height */\r\n  background-color: #f9f9f9; /* Optional background color */\r\n\r\n}\r\n\r\n.modulename {\r\n  font-size: 1.5em; /* Responsive font size */\r\n  font-weight: bold;\r\n  color: #333; /* Text color */\r\n  text-align: center; /* Ensure text alignment */\r\n}\r\n\r\n\r\n\r\n\r\n\r\n  \r\n/* **** Carousel css ***========================================================================================================== */\r\n\r\n/* Carousel.css */\r\n.carousel-container {\r\n  width: 150%;\r\n  /* height: 350px; */\r\n  /* margin-top: 90px; */\r\n  /* animation: zoom 10s infinite; */\r\n}\r\n\r\n.carousel-img{\r\n  height: 350px;\r\n}\r\n\r\n\r\n/* @keyframes zoom {\r\n  0% {\r\n    transform: scale(1); \r\n  }\r\n  50% {\r\n    transform: scale(1.05); \r\n  }\r\n  100% {\r\n    transform: scale(1); \r\n  }\r\n} */\r\n\r\n/* For laptop screens (1024px to 1440px) */\r\n@media (min-width: 1024px) and (max-width: 1440px) {\r\n  .carousel-container {\r\n    /* height: 300px; */\r\n    margin-top: 80px;\r\n    width: 100%;\r\n  }\r\n\r\n  .carousel-img{\r\n    height: 350px;\r\n  }\r\n}\r\n\r\n/* For tablets (768px to 1024px) */\r\n@media (max-width: 1024px) and (min-width: 769px) {\r\n  .carousel-container {\r\n    /* height: 250px; */\r\n    margin-top: 75px;\r\n  }\r\n\r\n  .carousel-img{\r\n    height: 350px;\r\n  }\r\n}\r\n\r\n/* For medium devices (up to 768px) */\r\n@media (max-width: 768px) {\r\n  .carousel-container {\r\n    width: 100%;\r\n    /* height: 200px; */\r\n    margin-top: 70px;\r\n  }\r\n\r\n  .carousel-img{\r\n    height: 200px;\r\n  }\r\n}\r\n\r\n/* For small devices (up to 576px) */\r\n@media (max-width: 576px) {\r\n  .carousel-container {\r\n    width: 100%;\r\n    /* height: 50px;  */\r\n    margin-top: 60px;\r\n  }\r\n\r\n  .carousel-img{\r\n    height: 150px;\r\n  }\r\n}\r\n\r\n\r\n/* ***********************  Horizontal Header css ********************* */\r\n\r\n\r\n/* Container for header list */\r\n.header-container {\r\n  /* margin-top: 50px; */\r\n  position: relative;\r\n  width: 100%;\r\n  /* overflow-x: auto; */\r\n  padding: 10px;\r\n  border-top: 1px solid #ccc;\r\n  border-bottom: 1px solid #ccc;\r\n  /* margin-left: 15px; */\r\n}\r\n\r\n/* Horizontal list styling */\r\n.header-list {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  list-style-type: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  flex-wrap: wrap;\r\n color:'black'\r\n}\r\n\r\n.header-item {\r\n  position: relative; /* Needed for the active bar positioning */\r\n  padding: 10px 20px;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  white-space: nowrap;\r\n  transition: color 0.3s ease;\r\n  text-align: center;\r\n  flex: 0 0 auto; /* Allow item to take its own width */\r\n}\r\n\r\n.header-item h6{\r\n  font-size: 1.0rem;\r\n}\r\n\r\n.header-item.active {\r\n  color:rgb(233,182,16);\r\n}\r\n\r\n/* Active bar inside the header-item */\r\n.active-bar {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  height: 3px;\r\n  width: 100%; /* Takes the full width of the header item */\r\n  background-color:rgb(255, 196, 0);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n\r\n/* Responsive styles */\r\n@media (max-width: 900px) {\r\n  .header-item h6{\r\n    font-size: 0.9rem;\r\n  }\r\n}\r\n\r\n\r\n/* Responsive styles */\r\n@media (max-width: 768px) {\r\n  .header-item {\r\n    font-size: 0.9rem;\r\n    padding: 8px 15px;\r\n  }\r\n\r\n  .header-item h6{\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .header-list {\r\n    justify-content: flex-start;\r\n    padding-left: 10px;\r\n  }\r\n\r\n  .header-item {\r\n    font-size: 0.8rem;\r\n    padding: 6px 10px;\r\n    flex: 0 0 auto;\r\n  }\r\n\r\n  .header-item h6{\r\n    font-size: 0.6rem;\r\n  }\r\n\r\n  .active-bar {\r\n    height: 2px;\r\n  }\r\n}\r\n\r\n\r\n\r\n/* *********** Card UI ******************** */\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.Mro-container {\r\n  display: flex;\r\n  justify-content: center; /* Centers the container horizontally */\r\n  align-items: center; /* Centers the container vertically */\r\n  padding: 20px;\r\n  width: 100%; /* Full width for responsiveness */\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Card wrapper: Left-aligned content within the centered container */\r\n.Mroimage-card {\r\n  display: flex;\r\n  flex-wrap: wrap; /* Allows wrapping to new rows */\r\n  gap: 20px; /* Space between cards */\r\n  justify-content: flex-start; /* Align cards to the left */\r\n\r\n}\r\n\r\n/* Individual card styling */\r\n.Mroimage-card-content {\r\n  background: rgba(237, 214, 115, 0.2);\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  padding: 20px;\r\n  box-shadow: 0 4px 8px rgba(237, 230, 230, 0.2);\r\n  backdrop-filter: blur(15px);\r\n  -webkit-backdrop-filter: blur(15px);\r\n  border: 4px solid rgb(251, 222, 6);\r\n  transition: transform 0.3s ease;\r\n  flex: 1 1 calc(25% - 20px); /* Default: 4 cards per row */\r\n  max-width: 250px; /* Prevent card from growing too large */\r\n  /* height: 400px; */\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  text-align: center;\r\n}\r\n.Mrocard-image {\r\n  width: 100%; /* Allow the image to take the full width of its container */\r\nheight: auto;\r\nmax-width: 200px; /* Default max width */\r\nmax-height: 200px; /* Default max height */\r\n object-fit: cover; /* Ensures the image fits within the specified dimensions */\r\n border-radius: 8px; /* Keep the rounded corners */\r\nmargin: 0 auto; /* Center the image horizontally */\r\n}\r\n\r\n.Mrocard-details {\r\n  text-align: center;\r\n  margin-top: 10px;\r\n}\r\n\r\n.Mrocard-details h2 {\r\n  font-size: 1em; /* Default font size for heading */\r\n  color: #120e0e;\r\n}\r\n\r\n.Mrocard-detailsOne,\r\n.Mrocard-detailsTwo {\r\n  margin: 5px;\r\n  font-size: 12px; /* Default font size */\r\n  color: #0e4306;\r\n}\r\n\r\n/* .MroImage-container{\r\nwidth:225px;\r\nmargin-left: -10px;\r\nmargin-top:-10px ;\r\nheight:900px;\r\n\r\n\r\n\r\n} */\r\n\r\n/* From 900px to 1280px: Maintain 4 cards per row */\r\n@media (max-width: 1280px) and (min-width: 901px) {\r\n  .Mroimage-card-content {\r\n    flex: 1 1 calc(25% - 20px); /* 4 cards per row */\r\n    max-width: 250px; /* Prevent card from growing too large */\r\n    height: 350px;\r\n  }\r\n\r\n  .Mrocard-image {\r\n    max-width: 180px;\r\n    max-height: 180px;\r\n    justify-content: center;\r\n    margin: 0 auto; /* Center the image horizontally */\r\n  }\r\n  .Mrocard-details h2 {\r\n    font-size: 1em;\r\n  }\r\n\r\n  .Mrocard-detailsOne,\r\n  .Mrocard-detailsTwo {\r\n    font-size: 12px;\r\n  }\r\n}\r\n/* From 600px to 900px: Show 3 cards per row */\r\n@media (max-width: 900px) and (min-width: 601px) {\r\n  .Mroimage-card-content {\r\n    flex: 1 1 calc(33.33% - 20px); /* 3 cards per row */\r\n    height: 300px;\r\n  }\r\n  .Mrocard-image {\r\n    max-width: 130px;\r\n    max-height: 130px;\r\n    margin: 0 auto; /* Center the image horizontally */\r\n  }\r\n  .Mrocard-details h2 {\r\n    font-size: 1em;\r\n  }\r\n  .Mrocard-detailsOne,\r\n  .Mrocard-detailsTwo {\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n/* From 400px to 599px: Show 2 cards per row */\r\n@media (max-width: 600px) and (min-width: 401px) {\r\n  .Mroimage-card-content {\r\n    flex: 1 1 calc(50% - 20px); /* 2 cards per row */\r\n  }\r\n  .Mrocard-image {\r\n    max-width: 130px;\r\n    max-height: 130px;\r\n  \r\n  }\r\n  .Mrocard-details h2 {\r\n    font-size: 0.9em;\r\n  }\r\n  .Mrocard-detailsOne,\r\n  .Mrocard-detailsTwo {\r\n    font-size: 11px;\r\n  }\r\n}\r\n\r\n/* Below 400px: Show 1 card per row */\r\n@media (max-width: 400px) {\r\n  .Mroimage-card-content {\r\n    flex: 1 1 calc(100% - 20px); /* 1 card per row */\r\n  }\r\n\r\n  .Mrocard-image {\r\n    max-width: 140px;\r\n    max-height: 140px;\r\n  }\r\n  .Mroimage-card {\r\n    justify-content: center;\r\n  }\r\n  .Mrocard-details h2 {\r\n    font-size: 0.8em;\r\n  }\r\n\r\n  .Mrocard-detailsOne,\r\n  .Mrocard-detailsTwo {\r\n    font-size: 10px;\r\n  }\r\n}\r\n\r\n\r\n/* *******************  Module-Container ************************* */\r\n/* CSS for the modules-container to look like a dropdown */\r\n.modules-container {\r\n  margin: 13px auto;\r\n  display: none;               /* Initially hidden */\r\n  position: absolute;          /* Positioned relative to the nearest positioned ancestor */\r\n  background-color: white;     /* Background color */\r\n  border: 2px solid rgb(255, 214, 11);      /* Light border */\r\n  border-radius: 4px;          /* Rounded corners */\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Shadow for depth */\r\n  z-index: 1000;              /* Ensure it's on top of other elements */\r\n  width: max-content;          /* Adjust width to content */\r\n  max-height: 300px;          /* Maximum height for dropdown */\r\n  overflow-y: auto;           /* Scroll if content exceeds max height */\r\n  padding: 10px;              /* Padding for better spacing */\r\n  left: 0px;\r\n  /* max-width: 70vw; */\r\n}\r\n\r\n/* Show the dropdown when the show class is applied */\r\n.modules-container.show {\r\n  display: block;              /* Show the dropdown */\r\n}\r\n\r\n/* Styles for individual module items */\r\n.module-item {\r\n  padding: 8px 12px;          /* Padding for each item */\r\n  cursor: pointer;            /* Pointer cursor */\r\n  transition: background-color 0.3s; /* Transition for hover effect */\r\n  text-align: left;\r\n  color:#0b0808\r\n}\r\n\r\n/* Change background color on hover for module items */\r\n.module-item:hover {\r\n  background-color:rgba(0, 0, 0, 0.2); /* Light gray background on hover */\r\n}\r\n\r\n/* Style for no modules available message */\r\n.modules-container p {\r\n  padding: 10px;              /* Padding for the message */\r\n  margin: 0;                  /* Remove margin */\r\n  color: #777;                /* Gray color for the message */\r\n       /* Center align the message */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
